import { useIsDesktop } from '@/hooks/useMediaQuery';

import './overlay.scss';

import { DesktopHeader } from './components/desktop/DesktopHeader';
import { MobileHeader } from './components/mobile/MobileHeader';

import type { HeaderData } from './types';

type HeaderProps = {
  data: HeaderData;
};

export function Header({ data }: HeaderProps) {
  // The full desktop nav only has comfortable clearance from ~1200px up — it
  // just avoids overlapping the logo/CTA around ~1075px and stays cramped through
  // the 1100s — so below the 1200px Laptop breakpoint the laptop range uses the
  // mobile structure rather than a squeezed desktop one.
  const hasRoomForDesktopNav = useIsDesktop();
  const menuItems = data.menu?.items ?? [];
  // Language switching disabled; retaining default calculations for quick restoration if needed.
  // const languages: NonNullable<HeaderData['language']['options']> = data.language?.options?.length
  //   ? (data.language.options as NonNullable<HeaderData['language']['options']>)
  //   : defaultLanguages;
  // const languageLabel = data.language?.label || languages[0]?.label || 'English';
  const primaryCta = data.cta?.label
    ? {
        label: data.cta.label,
        url: data.cta.url || '#',
      }
    : null;

  const sharedProps = {
    variant: data.variant ?? 'default',
    brand: data.brand,
    announcement: data.announcement,
    menuItems,
    cta: primaryCta,
    // languageLabel,
    // languages,
  } as const;

  return hasRoomForDesktopNav ? (
    <DesktopHeader {...sharedProps} />
  ) : (
    <MobileHeader {...sharedProps} />
  );
}

export default Header;
